import { z } from 'zod';

/**
 * Validation schema for player names
 * Matches database constraint: name ~ '^[a-zA-Z0-9 ]+$'
 */
export const playerNameSchema = z
  .string()
  .trim()
  .min(1, "Name cannot be empty")
  .max(20, "Name must be 20 characters or less")
  .regex(/^[a-zA-Z0-9 ]+$/, "Name can only contain letters, numbers, and spaces");

/**
 * Validation schema for room codes
 * Matches database constraint: id ~ '^[A-Z0-9]{6}$'
 */
export const roomCodeSchema = z
  .string()
  .trim()
  .length(6, "Room code must be exactly 6 characters")
  .regex(/^[A-Z0-9]{6}$/, "Room code must be 6 uppercase letters/numbers");

/**
 * Validates player name and returns error message if invalid
 */
export function validatePlayerName(name: string): string | null {
  try {
    playerNameSchema.parse(name);
    return null;
  } catch (err) {
    if (err instanceof z.ZodError) {
      return err.errors[0].message;
    }
    return "Invalid name";
  }
}

/**
 * Validates room code and returns error message if invalid
 */
export function validateRoomCode(code: string): string | null {
  try {
    roomCodeSchema.parse(code);
    return null;
  } catch (err) {
    if (err instanceof z.ZodError) {
      return err.errors[0].message;
    }
    return "Invalid room code";
  }
}
